import {REPORT_NEW_GEN0_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_GEN0_ORDERS,
};
